import { supabase } from '../lib/supabase';

/**
 * Save form exit feedback
 */
export const saveFormFeedback = async (feedbackData) => {
  try {
    const sessionId = sessionStorage.getItem('form_session_id');
    
    const feedback = {
      session_id: sessionId || `temp_${Date.now()}`,
      reason: feedbackData.reason || null,
      feedback_text: feedbackData.feedbackText || null,
      rating: feedbackData.rating || null,
      email: feedbackData.email || null
    };

    const { error } = await supabase
      .from('form_feedback')
      .insert([feedback]);

    if (error) {
      console.error('Error saving feedback:', error);
      return { success: false, error };
    }

    return { success: true };
  } catch (error) {
    console.error('Error saving feedback:', error);
    return { success: false, error };
  }
};

/**
 * Get all form feedback (for admin view)
 */
export const getAllFormFeedback = async () => {
  try {
    const { data, error } = await supabase
      .from('form_feedback')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching feedback:', error);
      return { success: false, error };
    }

    return { success: true, data };
  } catch (error) {
    console.error('Error fetching feedback:', error);
    return { success: false, error };
  }
};

/**
 * Get feedback statistics
 */
export const getFeedbackStats = async () => {
  try {
    const { data, error } = await supabase
      .from('form_feedback')
      .select('reason, rating');

    if (error) {
      console.error('Error fetching feedback stats:', error);
      return { success: false, error };
    }

    // Calculate statistics
    const reasonCount = {};
    let totalRating = 0;
    let ratingCount = 0;

    data.forEach(item => {
      if (item.reason) {
        reasonCount[item.reason] = (reasonCount[item.reason] || 0) + 1;
      }
      if (item.rating) {
        totalRating += item.rating;
        ratingCount++;
      }
    });

    return {
      success: true,
      stats: {
        total: data.length,
        reasonCount,
        averageRating: ratingCount > 0 ? (totalRating / ratingCount).toFixed(1) : 0,
        ratingCount
      }
    };
  } catch (error) {
    console.error('Error calculating feedback stats:', error);
    return { success: false, error };
  }
};

